<template>
  <v-card  class="kim-card plan-card text-xs-center" style="overflow: visible;" elevation="5">

    <v-card-title :class="['white--text title text-xs-centertext-truncate', cardColor]">

      <template v-if="plan.recommended">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn fab small absolute top right v-on="on" class="recommended-btn">
              <v-icon size="44" color="yellow darken-2">fa-bookmark</v-icon>
            </v-btn>
          </template>
          Destacado
        </v-tooltip>
      </template>



      <div class="title mx-auto ">
        {{plan.name}}
      </div>

      <v-flex xs12 pt-2 pb-0 text-xs-center>
        <div class="display-2 font-weight-regular text-xs-center">
          {{Math.floor(plan.amount * 100) / 100}} <span class="headline ">UF</span> <span class="body-1">/ Mes</span>
        </div>
      </v-flex>
      <v-flex py-0 xs12 text-xs-center>
        <small class="caption">*Valor no incluye IVA</small>
      </v-flex>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pb-0">
      <div class="body-1">{{plan.description}}</div>
      <v-divider class="mt-2" v-if="plan.description"></v-divider>

      <v-sheet>
        <v-list dense>
          <feature-item :color="cardColor" icon="fa-user-circle" :text="`${plan.max_specialists} ${proAccounts}`" />
          <feature-item v-if="plan.target === 'institution'" :color="cardColor" icon="fa-users" text="Cuentas administrativas ilimitadas" />
          <feature-item :color="cardColor" v-if="plan.target === 'institution'" icon="fas fa-building" :text="`${plan.max_branch_offices} ${branchOffices}`" />
          <feature-item :color="cardColor" icon="fa-calendar-alt" text="Agendas ilimitadas" />
          <feature-item :color="cardColor" icon="fa-clipboard-list" text="Ficha clínica" />
          <feature-item :color="cardColor" v-if="plan.features && plan.features.includes('payments')" icon="fa-money-check" text="Cobro de citas en línea" />
          <feature-item :color="cardColor" v-if="plan.features && plan.features.includes('public_profile')" icon="fa-globe" :text="`Perfil público para ${clientPlural.toLowerCase()}`" />
          <feature-item :color="cardColor" v-if="plan.features && plan.features.includes('vc')" icon="fa-video" text="Videoatención" />
        </v-list>
      </v-sheet>

    </v-card-text>
    <template  v-if="plan && plan.deleted_at">
      <v-card-text>
        <span class="caption">(Este plan fue Eliminado)</span>
      </v-card-text>
    </template>
    <template v-else>
      <template v-if="internal">

        <v-divider class="mt-2" ></v-divider>

        <div class="text-xs-center py-2">
          <small>Disponible <b>{{availableFor}}</b>.</small>
          <br/>
          <small>Creado por <b>{{plan.user.first_name}} {{plan.user.last_name}}</b></small>
        </div>

      </template>
      <v-card-actions v-if="internal" >
        <v-btn round :color="cardColor" class="white--text" style="width: 100%" @click="$emit('click:edit', plan)">
          <v-icon class="mr-2" size="16">fa-edit</v-icon>
          Editar
        </v-btn>
      </v-card-actions>

      <v-card-actions v-else >
        <v-btn :disabled="disablePurchase" round :color="cardColor" class="white--text" style="width: 100%" @click="$emit('click:purchase', plan)">
          <v-icon class="mr-2" size="16">fa-shopping-bag</v-icon>
          {{purchaseBtnLabel}}
        </v-btn>
      </v-card-actions>

    </template>

  </v-card>
</template>

<script>
import FeatureItem from "@/components/admin/FeatureItem";
export default {
  name: "PlanCard",
  components: {FeatureItem},
  props: {
    currentPlan: {
      type: Boolean,
      default: false
    },
    internal:{
      type: Boolean,
      default: false
    },
    plan:{
      type: Object,
      required: true
    },
    allowResubscribe: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    cardColor(){
      const vm = this

      if(vm.plan && vm.plan.recommended){
        return 'black'
      }

      if(vm.plan && vm.plan.deleted_at){
        return 'grey darken-1'
      }

      return 'primary'
    },
    provider(){
      const vm = this
      return vm.plan && vm.plan.service_provider || null
    },
    providerName(){
      const vm = this
      return vm.provider.institution ?
          vm.provider.institution.name :
          `${vm.provider.user.first_name} ${vm.provider.user.last_name}`
    },
    plural(){
      const vm = this
      return vm.plan && vm.plan.max_specialists > 1
    },
    proAccounts(){
      const vm = this
      return vm.plural ? 'cuentas profesionales' : 'cuenta profesional'
    },
    branchOffices(){
      const vm = this
      const plural = vm.plan.max_branch_offices > 1;
      return plural ? 'sucursales' : 'sucursal'
    },
    purchaseBtnLabel(){
      const vm = this
      if(vm.currentPlan && vm.allowResubscribe){
        return 'Volver a Contratar'
      }

      if(vm.currentPlan){
        return 'Plan Actual'
      }

      return 'Contratar'

    },
    disablePurchase(){
      const vm = this
      if(vm.currentPlan && !vm.allowResubscribe){
        return true
      }

      return false
    },
    availableFor(){
      const vm = this
      if(vm.provider){
        return `sólo para ${vm.providerName}`
      }

      if(vm.plan.target === 'all'){
        return 'para todos los pacientes'
      }

      if(vm.plan.target === 'individual'){
        return 'sólo para cuentas individuales'
      }

      return 'sólo para cuentas empresa'

    }
  }
}
</script>

<style scoped>
  .plan-card{
    padding: 0;
    transition: transform .2s ease-out;
  }

  .plan-card:hover{
    transform: scale(1.02);
  }

  .recommended-btn,
  .recommended-btn:hover{
    margin-top: 14px;
    background-color: transparent !important;
    box-shadow: none !important;
  }


</style>
